import React from 'react';
import './Hero.css';

export default function Hero() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="hero" className="hero">

      <div className="container hero-container">
        <div className="hero-grid">

          {/* ── Left ── */}
          <div className="hero-left">

            <div className="hero-eyebrow">
              India's Trusted Visa Documentation Partner
            </div>

            <h1 className="hero-h1">
              Your Trusted Partner<br />
              for <span className="hero-h1-accent">Visa &amp; Travel</span><br />
              Documentation
            </h1>

            <div className="hero-h1-underline"></div>

            <p className="hero-sub">
              Helping Indian travelers simplify tourist visas and travel
              documentation for destinations worldwide — through expert
              guidance and a completely hassle-free process.
            </p>

            <div className="hero-btns">
              <a
                href="#contact"
                className="hero-btn-apply"
                onClick={e => { e.preventDefault(); go('contact'); }}
              >
                <i className="fas fa-paper-plane"></i>
                Apply Now
              </a>
              <a
                href="https://wa.me/918287450060"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-btn-wa"
              >
                <i className="fab fa-whatsapp"></i>
                Chat on WhatsApp
              </a>
            </div>

            <div className="hero-trust">
              <div className="trust-item"><i className="fas fa-circle-check"></i> Transparent Process</div>
              <div className="trust-item"><i className="fas fa-circle-check"></i> Expert Guidance</div>
              <div className="trust-item"><i className="fas fa-circle-check"></i> Worldwide Destinations</div>
              <div className="trust-item"><i className="fas fa-circle-check"></i> Fast Assistance</div>
            </div>
          </div>

          {/* ── Right — Hero Image ── */}
          <div className="hero-right">
            <div className="hero-img-wrap">
              <img
                src="/ChatGPT Image Aug 8, 2026 at 12_10_39 PM.png"
                alt="RoamLife visa documentation — passport, application form, globe and visa stamp illustration"
                className="hero-img"
              />
            </div>
          </div>

        </div>


      </div>
    </section>
  );
}
